import React from 'react';
import { Grid, Box, Icon, Text, Radio, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, Tooltip, HStack, IconButton } from '@chakra-ui/react';
import { FaCheck } from 'react-icons/fa';
import { FiEdit } from 'react-icons/fi';
import { IoTrashOutline } from 'react-icons/io5';
import { IconCreditCards, getIconCard } from "../IconCreditCard";
import { noop } from "../../utils";
import { EditCreditCardModal } from "./EditCreditCardModal";
import { DeleteCreditCardModal } from "./DeleteCreditCardModal";
export var SelectCreditCard = function SelectCreditCard(props) {
  var renderCreditForm = props.renderCreditForm;

  var _a = useDisclosure(),
      isOpen = _a.isOpen,
      onOpen = _a.onOpen,
      onClose = _a.onClose;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    gridTemplateColumns: "max-content 1fr max-content",
    alignItems: "center",
    mb: "3"
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: "bold"
  }, "\u0E1A\u0E31\u0E15\u0E23\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15/\u0E1A\u0E31\u0E15\u0E23\u0E40\u0E14\u0E1A\u0E34\u0E15"), /*#__PURE__*/React.createElement(IconCreditCards, null), /*#__PURE__*/React.createElement(Box, {
    textDecoration: "underline",
    cursor: "pointer",
    userSelect: "none",
    fontWeight: "bold",
    color: "brand.400",
    onClick: onOpen,
    layerStyle: "actionable",
    id: "add-new-card-button"
  }, "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E31\u0E15\u0E23\u0E43\u0E2B\u0E21\u0E48")), props.children, /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onClose: onClose,
    blockScrollOnMount: false,
    isCentered: true
  }, /*#__PURE__*/React.createElement(ModalOverlay, null), /*#__PURE__*/React.createElement(ModalContent, {
    fontFamily: "body"
  }, /*#__PURE__*/React.createElement(ModalHeader, null, "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E31\u0E15\u0E23\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15 / \u0E40\u0E14\u0E1A\u0E34\u0E15 \u0E43\u0E2B\u0E21\u0E48"), /*#__PURE__*/React.createElement(ModalCloseButton, null), /*#__PURE__*/React.createElement(ModalBody, {
    pb: 6
  }, renderCreditForm && renderCreditForm({
    onClose: onClose
  })))));
};
export var CardItem = function CardItem(props) {
  var _a = props.isSelected,
      isSelected = _a === void 0 ? false : _a,
      _b = props.primary,
      primary = _b === void 0 ? false : _b,
      _c = props.onDelete,
      onDelete = _c === void 0 ? noop : _c,
      _d = props.onEdit,
      onEdit = _d === void 0 ? noop : _d,
      _e = props.onClick,
      _onClick = _e === void 0 ? noop : _e,
      cardType = props.cardType,
      shownNumber = props.shownNumber;

  var CardIcon = getIconCard(cardType);
  var editModalDisclosure = useDisclosure();
  var deleteModalDisclosure = useDisclosure();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    display: "grid",
    pr: "5",
    gridTemplateColumns: "1fr max-content",
    borderBottom: "1px solid",
    borderColor: "gray.200",
    alignItems: "center",
    backgroundColor: isSelected ? '#f6f6f6' : '#fff',
    _last: {
      border: 'none'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    gap: "2",
    p: "5",
    pr: "0",
    gridTemplateColumns: "repeat(3, max-content)",
    cursor: "pointer",
    userSelect: "none",
    alignItems: "center",
    layerStyle: "actionable",
    onClick: function onClick() {
      _onClick();
    }
  }, /*#__PURE__*/React.createElement(Radio, {
    mr: "2",
    isChecked: isSelected,
    onChange: noop,
    colorScheme: "brand",
    "data-testid": "select-credit-card"
  }), /*#__PURE__*/React.createElement(CardIcon, null), /*#__PURE__*/React.createElement(HStack, null, /*#__PURE__*/React.createElement(Box, null, shownNumber), isSelected && /*#__PURE__*/React.createElement(CheckIcon, null))), /*#__PURE__*/React.createElement(HStack, {
    spacing: "1",
    justifyContent: "flex-end",
    alignItems: "flex-start",
    color: "#444"
  }, !primary && /*#__PURE__*/React.createElement(Tooltip, {
    label: "\u0E41\u0E01\u0E49\u0E44\u0E02",
    hasArrow: true
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      as: FiEdit
    }),
    variant: "ghost",
    "data-testid": "address-edit",
    "aria-label": "edit address",
    onClick: editModalDisclosure.onOpen,
    fontSize: "md",
    size: "sm"
  })), /*#__PURE__*/React.createElement(Tooltip, {
    label: "\u0E25\u0E1A",
    hasArrow: true
  }, /*#__PURE__*/React.createElement(IconButton, {
    colorScheme: "red",
    color: "#c63636",
    icon: /*#__PURE__*/React.createElement(Icon, {
      as: IoTrashOutline
    }),
    variant: "ghost",
    "data-testid": "address-edit",
    "aria-label": "edit address",
    onClick: deleteModalDisclosure.onOpen,
    fontSize: "md",
    size: "sm"
  })))), !primary && /*#__PURE__*/React.createElement(EditCreditCardModal, {
    disclosure: editModalDisclosure,
    isPrimary: primary,
    onConfirm: onEdit
  }), /*#__PURE__*/React.createElement(DeleteCreditCardModal, {
    disclosure: deleteModalDisclosure,
    onConfirm: onDelete
  }));
};
export var EmptyCardList = function EmptyCardList() {
  return /*#__PURE__*/React.createElement(Box, {
    p: "4",
    my: "6",
    textAlign: "center",
    color: "gray.400"
  }, "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E1A\u0E31\u0E15\u0E23\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15");
};

var CheckIcon = function CheckIcon() {
  return /*#__PURE__*/React.createElement(Box, {
    width: "16px",
    height: "16px",
    backgroundColor: "brand.400",
    borderRadius: "100px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mr: "2",
    id: "address-check-icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    as: FaCheck,
    color: "white",
    boxSize: "10px"
  }));
};